module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/newbackground-light-b3587f722dab257f956e0d2095384a1a.jpg";